import { render } from "./HomeHelpIn.vue?vue&type=template&id=8f01e9e4"
import script from "./HomeHelpIn.vue?vue&type=script&lang=js"
export * from "./HomeHelpIn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__